__turbopack_context__.v({
  "footer": "DialogFooter-module__dwYPlW__footer",
});
